import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import PassDownloadTemplateContext from '../store/client/PassDownloadTemplateContext';
import { useToast } from '@chakra-ui/react';
import { HttpContext } from '../context/HttpContext';
import { useReportAndToastApiError } from './useReportAndToastApiError';

function UsePassDownloadTemplate({ children }) {
  const { authAxios } = useContext(HttpContext);
  const { uuid } = useParams();
  const navigate = useNavigate();
  const passDownloadCtx = useContext(PassDownloadTemplateContext);
  const toast = useToast();
  const reportAndToastApiError = useReportAndToastApiError();

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await authAxios.get(
          `api/v1/pass_download_templates/${uuid}`
        );
        const data = response.data?.data?.attributes;
        passDownloadCtx.updateAllData(data);
      } catch (onError) {
        reportAndToastApiError(onError);
        navigate('/pass-download', { replace: true });
      }
    };

    getData();
  }, [authAxios]);

  return <>{children}</>;
}

export default UsePassDownloadTemplate;
